import AiTitleMetaRewriter from './AiTitleMetaRewriter.component';

export default AiTitleMetaRewriter;
